import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ETATS_EQUIPEMENT } from '@eec/contrats';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
import { useSession } from '../../session/FournisseurSession';

export function PrioritesPatrimoine() {
  const { contexte } = useSession();
  const [ouvert, setOuvert] = useState(false);
  const q = useQuery({
    queryKey: ['patrimoine', 'priorites', contexte?.appartenance_active?.id],
    enabled: ouvert,
    queryFn: () =>
      requete<{
        tronque: boolean;
        elements: {
          id: string;
          code: string;
          nom: string;
          criticite: number;
          statut: keyof typeof ETATS_EQUIPEMENT;
          localisation: string;
          incidents_a_suivre: number;
        }[];
      }>('/patrimoine/priorites'),
  });
  return (
    <details onToggle={(e) => setOuvert(e.currentTarget.open)}>
      <summary>Surveillance des équipements prioritaires</summary>
      <p>
        Vue interne à votre organisation : équipements de criticité 3 ou 4, hors équipements
        retirés. Classement par criticité, puis par nombre d’incidents à suivre. Aucune donnée de
        cette liste n’est publiée sur le portail citoyen.
      </p>
      <p>
        Le nombre compte les incidents liés dont le rétablissement n’est pas vérifié, hors dossiers
        clôturés, non confirmés ou annulés. Il ne mesure pas la disponibilité du réseau.
      </p>
      {ouvert && q.isPending && <p role="status">Chargement des priorités…</p>}
      {q.error && <p role="alert">{messageErreur(q.error)}</p>}
      {q.data && (
        <>
          {q.data.tronque && (
            <p role="alert">Les 500 premiers équipements sont affichés. La liste est incomplète.</p>
          )}
          {!q.data.elements.length && (
            <p>Aucun équipement de criticité 3 ou 4 en activité enregistré.</p>
          )}
          <ul style={{ paddingLeft: 20 }}>
            {q.data.elements.map((e) => (
              <li key={e.id} style={{ marginBlock: 16 }}>
                <strong>
                  {e.code} — {e.nom}
                </strong>
                <p>
                  Criticité {e.criticite} · {ETATS_EQUIPEMENT[e.statut]} · {e.incidents_a_suivre}{' '}
                  incident(s) à suivre
                </p>
                <p>{e.localisation}</p>
              </li>
            ))}
          </ul>
          <button onClick={() => void q.refetch()} disabled={q.isFetching}>
            Actualiser les priorités
          </button>
        </>
      )}
    </details>
  );
}
